import { formatCurrencyAmount } from '@p2p/shared/functions';
import classNames from 'classnames';

import styles from './AmountsItem.module.scss';

type AmountsItemProps = {
  amount: number;
  isSelected: boolean;
  onClick: () => void;
};

export const AmountsItem = ({ amount, isSelected, onClick }: AmountsItemProps) => {
  return (
    <button
      type="button"
      className={classNames(styles.amount, {
        [styles.amountSelected]: isSelected,
      })}
      onClick={onClick}
    >
      {formatCurrencyAmount(amount, { showSymbol: true })}
    </button>
  );
};
